export const schoolType = [
   {
      label: "Day Only",
      value: "day_only",
   },
   {
      label: "Boarding",
      value: "boarding_only",
   },
   {
      label: "Boarding & Day",
      value: "boarding_and_day",
   },
   {
      label: "Online",
      value: "online",
   },
   {
      label: "Tutorial Center",
      value: "tutorial_center",
   },
];

export const schoolFees = [
   {
      label: "1,000 - 50,000",
      value: "1000-50000",
   },
   {
      label: "51,000 - 100,000",
      value: "51000-100000",
   },
   {
      label: "101,000 - 200,000",
      value: "101000-200000",
   },
   {
      label: "201,000 - 500,000",
      value: "201000-500000",
   },
   {
      label: "Above 500,000",
      value: "above-500000",
   },
];

export const schoolCategory = [
   {
      label: "Crèche/Pre-School",
      value: "creche",
   },
   {
      label: "Montessori",
      value: "montessori",
   },
   {
      label: "Nursery and Primary",
      value: "nursery_and_primary",
   },
   {
      label: "Online Schools/E-Learning",
      value: "online_school",
   },
   {
      label: "Secondary/High School",
      value: "high_school",
   },
   {
      label: "Sixth-form/Pre Degree Foundation",
      value: "pre_degree_foundation",
   },
   {
      label: "Tertiary",
      value: "tertiary",
   },
   {
      label: "Special School",
      value: "special_school",
   },
   {
      label: "Training/Business School",
      value: "business_school",
   },
   {
      label: "All",
      value: "all",
   },
];
